export default "__VITE_ASSET__1346285d__"